import { memo } from 'react'
import { Skeleton } from '@/components/ui/skeleton'
import { SkeletonAccordionItem } from './accordion'

const TotalResultSkeleton = memo(() => (
  <div className='flex flex-col gap-8'>
    <SkeletonAccordionItem defaultOpen />
    <SkeletonAccordionItem defaultOpen />
    <SkeletonAccordionItem defaultOpen />
  </div>
))

TotalResultSkeleton.displayName = `TotalResultSkeleton`

const SingleTableSkeleton = memo(() => <Skeleton className='h-full min-h-[400px] w-full animate-pulse rounded-lg' />)

SingleTableSkeleton.displayName = `SingleTableSkeleton`

export { TotalResultSkeleton, SingleTableSkeleton }
